import { Flex, SimpleGrid } from '@mantine/core';
import colors from 'common/constants/colors.styles';
import { Filter } from 'common/repositories/common.model';
import { FilterHandleProvider } from 'hooks/filter/use-filter-handle-component';
import useFilterHandleParent from 'hooks/filter/use-filter-handle-parent';
import useFilterHandleTransformer from 'hooks/filter/use-filter-handle-transformer';
import useCombinedRefs from 'hooks/use-combined-refs';
import Drawer, { DrawerRefType } from 'mantine-components/widget/drawer';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import UniskaiButton from 'templates/actions/uniskai-button';

import UniskaiFilterInput from './uniskai-filter-input';

interface UniskaiFilterDrawerProps {
  isUseResponseOptions?: boolean;
}

const UniskaiFilterDrawer = React.forwardRef<
  DrawerRefType,
  UniskaiFilterDrawerProps
>((props, ref) => {
  const { t } = useTranslation();
  const { isUseResponseOptions } = props;
  const [filters, setFilters] = React.useState<Filter[]>([]);
  const backendFilters = useFilterHandleParent();
  const clientFilters = useFilterHandleTransformer(filters, setFilters);

  const firstTime = React.useRef(true);
  const innerRef = React.useRef<DrawerRefType>(null);
  const combinedRef = useCombinedRefs(innerRef, ref);

  React.useEffect(() => {
    if (Array.isArray(backendFilters.filters) === false) return;
    setFilters(backendFilters?.filters || []);
    firstTime.current = false;
  }, [backendFilters.filters]);

  return (
    <Drawer
      title={t('common:filter')}
      ref={combinedRef as any}
      position="right"
      size={600}
    >
      <FilterHandleProvider
        filters={filters}
        setFilters={setFilters}
        isUseResponseOptions={isUseResponseOptions}
      >
        <SimpleGrid
          cols={{
            md: 2,
            base: 1,
          }}
          pb={56}
        >
          {filters.map((filter) => {
            return <UniskaiFilterInput key={filter.name} filter={filter} />;
          })}
        </SimpleGrid>
        <Flex
          direction="row"
          gap={16}
          align="center"
          justify="start"
          pos="fixed"
          p={16}
          bottom={0}
          right={0}
          left={0}
          bg={colors.white}
        >
          <UniskaiButton
            type="reset"
            variant="subtle"
            onClick={() => {
              innerRef.current?.close();
              backendFilters.onClearFilters(filters);
              clientFilters.onClearFilters(filters);
            }}
          />
          <UniskaiButton
            type="filter"
            variant="filled"
            flex={1}
            onClick={() => {
              innerRef.current?.close();
              backendFilters.onChangeFilters(filters);
            }}
          />
        </Flex>
      </FilterHandleProvider>
    </Drawer>
  );
});

export default UniskaiFilterDrawer;
